<template>
  <layout-register :error="true" :step="step" :title-step="$t('m158')">
    <form @submit="goToPayment">
      <div class="container-fluid p0">
        <div class="row">
          <div
            class="col-md-12 col-xs-12 col-sm-12 col-12 payment-error-container"
          >
            <img
              class="payment-error-img"
              src="@/assets/ilustracion-error-metodo-pago.png"
            />
            <p class="payment-error-p" v-html="$t('m157')"></p>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-7 col-xs-12 col-sm-12 col-12">
            <a-btn
              class="next-step-button"
              primary
              type="submit"
              :loading="loadingBtn"
            >
              {{ $t('m159') }}
            </a-btn>
          </div>
        </div>
      </div>
    </form>
  </layout-register>
</template>

<script>
import ABtn from '@/components/ui/ABtn';

export default {
  name: 'PaymentError',
  components: {
    ABtn,
  },
  data() {
    return {
      step: 9,
      titlePage: this.$t('m176'),
      nextBtnText: this.$t('m159'),
      loadingBtn: false,
    };
  },
  methods: {
    goToPayment() {
      this.$router.push({ name: 'PAYMENT' });
    },
  },
  mounted() {
    const payment = this.$store.getters['register/getPaymentMethodId'];
    if (!payment) {
      const registrationStep = this.$store.getters['register/registrationStep'];
      if (registrationStep) {
        this.$router.push({ name: registrationStep });
      } else {
        this.$router.push({ name: 'login' });
      }
    }
  },
};
</script>
